import styled from "styled-components";
export var OldHeading1 =
/*#__PURE__*/
styled.h1.withConfig({
  displayName: "OldHeading1"
})(["color:#16386b;"]);
export var OldHeading2 =
/*#__PURE__*/
styled.h2.withConfig({
  displayName: "OldHeading2"
})(["color:", ";margin:30px 0;margin-top:", ";padding-bottom:10px;@media (min-width:651px){padding-bottom:0;}"], function (_ref) {
  var color = _ref.color,
      theme = _ref.theme;
  return color || theme.headingColor || "#002272";
}, function (props) {
  return props.headingTopSpacing || "30px";
});
export var OldHeading3 =
/*#__PURE__*/
styled.h3.withConfig({
  displayName: "OldHeading3"
})(["", ""], function (_ref2) {
  var color = _ref2.color,
      theme = _ref2.theme;
  return "\n    color: " + (color || theme.headingColor || "inherit") + ";\n    margin-bottom: 0;\n  ";
}); // TODO: Transfer to xecom (or, if possible, just nuke it).

export var Slogan =
/*#__PURE__*/
styled.h1.withConfig({
  displayName: "Slogan"
})(["color:white;font-size:3.75vw;letter-spacing:1px;padding-left:10px;@media (min-width:651px){padding-left:32px;}@media (min-width:768px){font-size:3rem;}@media (min-width:994px){padding:0;}", ""], function (_ref3) {
  var isMobile = _ref3.isMobile;
  return "\n    margin-bottom: " + (isMobile ? "0.67em" : "1.67em") + ";\n  ";
}); // TODO: Transfer to xecom (or, if possible, just nuke it).

export var IndicatedHeading1 =
/*#__PURE__*/
styled(Slogan).withConfig({
  displayName: "IndicatedHeading1"
})(["", " margin-top:0;"], function (props) {
  var isMobile = props.isMobile,
      isRtl = props.isRtl;
  var direction = isRtl ? "right" : "left";
  var bidirectionalStyles = "\n      border: solid #fcb813;\n      color: #fff;\n      margin-" + direction + ": -20px;\n      padding-" + direction + ": " + (isMobile ? "12px" : "20px") + ";\n\n      @media (max-width: 993px) {\n        margin-" + direction + ": 0;\n      }\n\n      @media (max-width: 650px) {\n        border-width: " + (isRtl ? "0 3px 0 0" : "0 0 0 3px") + ";\n        padding: " + (isRtl ? "0 7px 0 0" : "0 0 0 7px") + ";\n      }\n    ";

  var getLtrStyles = function getLtrStyles() {
    return "\n      border-width: " + (isMobile ? "0 0 0 6px" : "0 0 0 5px") + ";\n    ";
  };

  var getRtlStyles = function getRtlStyles() {
    return "\n      border-width: " + (isMobile ? "0 6px 0 0" : "0 5px 0 0") + ";\n    ";
  };

  return bidirectionalStyles + (isRtl ? getRtlStyles() : getLtrStyles());
});
IndicatedHeading1.defaultProps = {
  isMobile: false,
  isRtl: false
};